import { LanguageEn } from './en';
import { LanguagePt } from './pt';
import { LanguageEs } from './es';

export const Languages: Record<any, any | undefined> = {
  ...LanguagePt,
  ...LanguageEn,
  ...LanguageEs,
};
